import { createRouter, initPxTransform } from '@tarojs/taro'
import component from "./app"
import { createReactApp, window } from '@tarojs/runtime'

import * as React from 'react'
import ReactDOM from 'react-dom'


import { defineCustomElements, applyPolyfills } from '@tarojs/components/loader'
import '@tarojs/components/dist/taro-components/taro-components.css'

applyPolyfills().then(function () {
  defineCustomElements(window)
})

var config = {"router":{"mode":"browser"},"pages":["pages/home/index","pages/constructionProject/index","pages/leafFiles/index","pages/commentList/index","pages/constructionFiles/index","pages/constructionDrawing/index","pages/filesMoveTo/index","pages/selectMember/index","pages/pdfView/index","pages/axiosDemo/index","pages/jssdkDemo/index","pages/constructionDrawing/index","pages/executionProgress/index","pages/executionProgress/ProgressTimeLine","pages/executionProgress/ProgressDetail","pages/executionProgress/MemberManage","pages/executionProgress/AccessoryList","pages/executionProgress/ModifyScheme","pages/executionProgress/PostDynamic","pages/executionProgress/RejectReason","pages/executionProgress/ProgressCheck","pages/executionProgress/CheckList","pages/executionProgress/CheckResult","pages/executionProgress/FinishDetail","pages/executionProgress/MemberSelect","pages/executionProgress/PlanDrawing","pages/login/index","pages/projectSpace/ProjectCheck","pages/projectSpace/ProjectCheckResult","pages/teamManage/InviteMembers","pages/commonPages/miniSDK-PreviewPDF","pages/projectSpace/projectDetail","pages/webView","pages/projectSpace/TeamMembers","pages/projectSpace/SelectRole","pages/projectSpace/AuthConfig","pages/projectSpace/ProjectList","pages/executionProgress/ShareAdjunct","pages/postponePlan/index","pages/mine/index","pages/mine/MessageNotification","pages/postponePlan/index","pages/constantsPage/index","pages/constantsPage/EditConstant","pages/landingPage","pages/landingPage/freeUse","pages/landingPage/getService","pages/landingPage/useSuccess","pages/commonPages/DownloadFile","pages/landingPage/freeUseNotWx","pages/projectSpace/ProjectPaymentTab/PaymentEditor","pages/executionProgress/AdditionalEditor","pages/executionProgress/AdditionalDetail","pages/landingPage/IntelligentDesign","pages/landingPage/IntelligentDesignPad","pages/landingPage/downloadApp","pages/landingPage/nationalDayBenefit","pages/landingPage/mobileAndPadPage/homePage","pages/landingPage/mobileAndPadPage/solution/commercialRealEstate","pages/landingPage/mobileAndPadPage/solution/marketingDesign","pages/landingPage/mobileAndPadPage/solution/assembledCeiling","pages/landingPage/mobileAndPadPage/business/cooperate","pages/landingPage/mobileAndPadPage/business/settled","pages/appLogin/index","pages/appLogin/login","pages/appLogin/rouseAppPage","pages/padLogin/login","pages/padLogin/selectOrganization","pages/padLogin/resetPassword","pages/padLogin/SelectIdentity","pages/mine/pad","pages/appPage/ClueManagement","pages/appPage/ClueDetail","pages/padLogin/rouseAppPage","pages/appOutLink/index","pages/mine/padAbout","pages/mine/accountCancellation","pages/appPage/neighborhoodSearch","pages/appPage/neighborhoodDetail","pages/appPage/houseTypeDetail","pages/appPage/HouseTypeLibrary","pages/appPage/DesignHome","pages/appPage/DesignSearch","pages/appPage/DesignDetail","pages/appPage/DesignDetailMobile","pages/appPage/DesignShare","pages/appPage/MyConstribute","pages/schemePreview/drawing","pages/appPage/AIGenerate","pages/appPage/InspirationList","pages/appPage/FullHousePreview","pages/appPage/DesignHelp","pages/appPage/ProxyDesignRefund","pages/appPage/FloorPlan","pages/appPage/FloorPlanDetail","pages/appPage/FloorPlanAction","pages/appPage/agree","pages/appPage/editModalPage","pages/hdd/panoramaShare","pages/member/buyMember","pages/member/payOrder","pages/appPage/MineModal","pages/appPage/ExcellentDesign3D","pages/activityPage/ReceiveWelfare","pages/appPage/customerAcquisition/AcquisitionList","pages/appPage/customerAcquisition/CollectionList","pages/appPage/customerAcquisition/preview3D","pages/panoramaExample/panorama3D","pages/panoramaExample/panoramaList","pages/appPage/InputReferrer","pages/designPreview/index","pages/appPage/FreeDesign","pages/landingPage/combo","pages/appPage/AgreementPage","pages/appPage/appPicker","pages/appPage/videoPage/index","pages/appPage/legalNoticePage/index","pages/qiweiPage/index","pages/landingPage/mobileAndPadPage/solution/paramsEdit","pages/landingPage/mobileAndPadPage/solution/technicalAuth","pages/landingPage/mobileAndPadPage/solution/digitalDrawing","pages/landingPage/mobileAndPadPage/solution/materialDownload"],"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"WeChat","navigationBarTextStyle":"black"}}
window.__taroAppConfig = config

if (config.tabBar) {
  var tabbarList = config.tabBar.list
  for (var i = 0; i < tabbarList.length; i++) {
    var t = tabbarList[i]
    if (t.iconPath) {
      t.iconPath = tabbarIconPath[i]
    }
    if (t.selectedIconPath) {
      t.selectedIconPath = tabbarSelectedIconPath[i]
    }
  }
}
config.routes = [
  
  Object.assign({
      path: 'pages/home/index',
      load: function() {
          return import("./pages/home/index")
      }
  }, require("./pages/home/index.config.js").default || {}),

  Object.assign({
      path: 'pages/constructionProject/index',
      load: function() {
          return import("./pages/constructionProject/index")
      }
  }, require("./pages/constructionProject/index.config.js").default || {}),

  Object.assign({
      path: 'pages/leafFiles/index',
      load: function() {
          return import("./pages/leafFiles/index")
      }
  }, require("./pages/leafFiles/index.config.js").default || {}),

  Object.assign({
      path: 'pages/commentList/index',
      load: function() {
          return import("./pages/commentList/index")
      }
  }, require("./pages/commentList/index.config.js").default || {}),

  Object.assign({
      path: 'pages/constructionFiles/index',
      load: function() {
          return import("./pages/constructionFiles/index")
      }
  }, require("./pages/constructionFiles/index.config.js").default || {}),

  Object.assign({
      path: 'pages/constructionDrawing/index',
      load: function() {
          return import("./pages/constructionDrawing/index")
      }
  }, require("./pages/constructionDrawing/index.config.js").default || {}),

  Object.assign({
      path: 'pages/filesMoveTo/index',
      load: function() {
          return import("./pages/filesMoveTo/index")
      }
  }, require("./pages/filesMoveTo/index.config.js").default || {}),

  Object.assign({
      path: 'pages/selectMember/index',
      load: function() {
          return import("./pages/selectMember/index")
      }
  }, require("./pages/selectMember/index.config.js").default || {}),

  Object.assign({
      path: 'pages/pdfView/index',
      load: function() {
          return import("./pages/pdfView/index")
      }
  }, require("./pages/pdfView/index.config.js").default || {}),

  Object.assign({
      path: 'pages/axiosDemo/index',
      load: function() {
          return import("./pages/axiosDemo/index")
      }
  }, require("./pages/axiosDemo/index.config.js").default || {}),

  Object.assign({
      path: 'pages/jssdkDemo/index',
      load: function() {
          return import("./pages/jssdkDemo/index")
      }
  }, require("./pages/jssdkDemo/index.config.js").default || {}),

  Object.assign({
      path: 'pages/constructionDrawing/index',
      load: function() {
          return import("./pages/constructionDrawing/index")
      }
  }, require("./pages/constructionDrawing/index.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/index',
      load: function() {
          return import("./pages/executionProgress/index")
      }
  }, require("./pages/executionProgress/index.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/ProgressTimeLine',
      load: function() {
          return import("./pages/executionProgress/ProgressTimeLine")
      }
  }, require("./pages/executionProgress/ProgressTimeLine.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/ProgressDetail',
      load: function() {
          return import("./pages/executionProgress/ProgressDetail")
      }
  }, require("./pages/executionProgress/ProgressDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/MemberManage',
      load: function() {
          return import("./pages/executionProgress/MemberManage")
      }
  }, require("./pages/executionProgress/MemberManage.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/AccessoryList',
      load: function() {
          return import("./pages/executionProgress/AccessoryList")
      }
  }, require("./pages/executionProgress/AccessoryList.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/ModifyScheme',
      load: function() {
          return import("./pages/executionProgress/ModifyScheme")
      }
  }, require("./pages/executionProgress/ModifyScheme.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/PostDynamic',
      load: function() {
          return import("./pages/executionProgress/PostDynamic")
      }
  }, require("./pages/executionProgress/PostDynamic.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/RejectReason',
      load: function() {
          return import("./pages/executionProgress/RejectReason")
      }
  }, require("./pages/executionProgress/RejectReason.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/ProgressCheck',
      load: function() {
          return import("./pages/executionProgress/ProgressCheck")
      }
  }, require("./pages/executionProgress/ProgressCheck.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/CheckList',
      load: function() {
          return import("./pages/executionProgress/CheckList")
      }
  }, require("./pages/executionProgress/CheckList.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/CheckResult',
      load: function() {
          return import("./pages/executionProgress/CheckResult")
      }
  }, require("./pages/executionProgress/CheckResult.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/FinishDetail',
      load: function() {
          return import("./pages/executionProgress/FinishDetail")
      }
  }, require("./pages/executionProgress/FinishDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/MemberSelect',
      load: function() {
          return import("./pages/executionProgress/MemberSelect")
      }
  }, require("./pages/executionProgress/MemberSelect.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/PlanDrawing',
      load: function() {
          return import("./pages/executionProgress/PlanDrawing")
      }
  }, require("./pages/executionProgress/PlanDrawing.config.js").default || {}),

  Object.assign({
      path: 'pages/login/index',
      load: function() {
          return import("./pages/login/index")
      }
  }, require("./pages/login/index.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/ProjectCheck',
      load: function() {
          return import("./pages/projectSpace/ProjectCheck")
      }
  }, require("./pages/projectSpace/ProjectCheck.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/ProjectCheckResult',
      load: function() {
          return import("./pages/projectSpace/ProjectCheckResult")
      }
  }, require("./pages/projectSpace/ProjectCheckResult.config.js").default || {}),

  Object.assign({
      path: 'pages/teamManage/InviteMembers',
      load: function() {
          return import("./pages/teamManage/InviteMembers")
      }
  }, require("./pages/teamManage/InviteMembers.config.js").default || {}),

  Object.assign({
      path: 'pages/commonPages/miniSDK-PreviewPDF',
      load: function() {
          return import("./pages/commonPages/miniSDK-PreviewPDF")
      }
  }, require("./pages/commonPages/miniSDK-PreviewPDF.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/projectDetail',
      load: function() {
          return import("./pages/projectSpace/projectDetail")
      }
  }, require("./pages/projectSpace/projectDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/webView',
      load: function() {
          return import("./pages/webView")
      }
  }, require("./pages/webView/index.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/TeamMembers',
      load: function() {
          return import("./pages/projectSpace/TeamMembers")
      }
  }, require("./pages/projectSpace/TeamMembers.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/SelectRole',
      load: function() {
          return import("./pages/projectSpace/SelectRole")
      }
  }, require("./pages/projectSpace/SelectRole.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/AuthConfig',
      load: function() {
          return import("./pages/projectSpace/AuthConfig")
      }
  }, require("./pages/projectSpace/AuthConfig.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/ProjectList',
      load: function() {
          return import("./pages/projectSpace/ProjectList")
      }
  }, require("./pages/projectSpace/ProjectList.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/ShareAdjunct',
      load: function() {
          return import("./pages/executionProgress/ShareAdjunct")
      }
  }, require("./pages/executionProgress/ShareAdjunct.config.js").default || {}),

  Object.assign({
      path: 'pages/postponePlan/index',
      load: function() {
          return import("./pages/postponePlan/index")
      }
  }, require("./pages/postponePlan/index.config.js").default || {}),

  Object.assign({
      path: 'pages/mine/index',
      load: function() {
          return import("./pages/mine/index")
      }
  }, require("./pages/mine/index.config.js").default || {}),

  Object.assign({
      path: 'pages/mine/MessageNotification',
      load: function() {
          return import("./pages/mine/MessageNotification")
      }
  }, require("./pages/mine/MessageNotification.config.js").default || {}),

  Object.assign({
      path: 'pages/postponePlan/index',
      load: function() {
          return import("./pages/postponePlan/index")
      }
  }, require("./pages/postponePlan/index.config.js").default || {}),

  Object.assign({
      path: 'pages/constantsPage/index',
      load: function() {
          return import("./pages/constantsPage/index")
      }
  }, require("./pages/constantsPage/index.config.js").default || {}),

  Object.assign({
      path: 'pages/constantsPage/EditConstant',
      load: function() {
          return import("./pages/constantsPage/EditConstant")
      }
  }, require("./pages/constantsPage/EditConstant.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage',
      load: function() {
          return import("./pages/landingPage")
      }
  }, require("./pages/landingPage/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/freeUse',
      load: function() {
          return import("./pages/landingPage/freeUse")
      }
  }, require("./pages/landingPage/freeUse.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/getService',
      load: function() {
          return import("./pages/landingPage/getService")
      }
  }, require("./pages/landingPage/getService.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/useSuccess',
      load: function() {
          return import("./pages/landingPage/useSuccess")
      }
  }, require("./pages/landingPage/useSuccess.config.js").default || {}),

  Object.assign({
      path: 'pages/commonPages/DownloadFile',
      load: function() {
          return import("./pages/commonPages/DownloadFile")
      }
  }, require("./pages/commonPages/DownloadFile.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/freeUseNotWx',
      load: function() {
          return import("./pages/landingPage/freeUseNotWx")
      }
  }, require("./pages/landingPage/freeUseNotWx.config.js").default || {}),

  Object.assign({
      path: 'pages/projectSpace/ProjectPaymentTab/PaymentEditor',
      load: function() {
          return import("./pages/projectSpace/ProjectPaymentTab/PaymentEditor")
      }
  }, require("./pages/projectSpace/ProjectPaymentTab/PaymentEditor.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/AdditionalEditor',
      load: function() {
          return import("./pages/executionProgress/AdditionalEditor")
      }
  }, require("./pages/executionProgress/AdditionalEditor.config.js").default || {}),

  Object.assign({
      path: 'pages/executionProgress/AdditionalDetail',
      load: function() {
          return import("./pages/executionProgress/AdditionalDetail")
      }
  }, require("./pages/executionProgress/AdditionalDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/IntelligentDesign',
      load: function() {
          return import("./pages/landingPage/IntelligentDesign")
      }
  }, require("./pages/landingPage/IntelligentDesign.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/IntelligentDesignPad',
      load: function() {
          return import("./pages/landingPage/IntelligentDesignPad")
      }
  }, require("./pages/landingPage/IntelligentDesignPad.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/downloadApp',
      load: function() {
          return import("./pages/landingPage/downloadApp")
      }
  }, require("./pages/landingPage/downloadApp.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/nationalDayBenefit',
      load: function() {
          return import("./pages/landingPage/nationalDayBenefit")
      }
  }, require("./pages/landingPage/nationalDayBenefit.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/homePage',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/homePage")
      }
  }, require("./pages/landingPage/mobileAndPadPage/homePage/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/solution/commercialRealEstate',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/solution/commercialRealEstate")
      }
  }, require("./pages/landingPage/mobileAndPadPage/solution/commercialRealEstate/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/solution/marketingDesign',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/solution/marketingDesign")
      }
  }, require("./pages/landingPage/mobileAndPadPage/solution/marketingDesign/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/solution/assembledCeiling',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/solution/assembledCeiling")
      }
  }, require("./pages/landingPage/mobileAndPadPage/solution/assembledCeiling/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/business/cooperate',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/business/cooperate")
      }
  }, require("./pages/landingPage/mobileAndPadPage/business/cooperate/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/business/settled',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/business/settled")
      }
  }, require("./pages/landingPage/mobileAndPadPage/business/settled/index.config.js").default || {}),

  Object.assign({
      path: 'pages/appLogin/index',
      load: function() {
          return import("./pages/appLogin/index")
      }
  }, require("./pages/appLogin/index.config.js").default || {}),

  Object.assign({
      path: 'pages/appLogin/login',
      load: function() {
          return import("./pages/appLogin/login")
      }
  }, require("./pages/appLogin/login.config.js").default || {}),

  Object.assign({
      path: 'pages/appLogin/rouseAppPage',
      load: function() {
          return import("./pages/appLogin/rouseAppPage")
      }
  }, require("./pages/appLogin/rouseAppPage.config.js").default || {}),

  Object.assign({
      path: 'pages/padLogin/login',
      load: function() {
          return import("./pages/padLogin/login")
      }
  }, require("./pages/padLogin/login.config.js").default || {}),

  Object.assign({
      path: 'pages/padLogin/selectOrganization',
      load: function() {
          return import("./pages/padLogin/selectOrganization")
      }
  }, require("./pages/padLogin/selectOrganization.config.js").default || {}),

  Object.assign({
      path: 'pages/padLogin/resetPassword',
      load: function() {
          return import("./pages/padLogin/resetPassword")
      }
  }, require("./pages/padLogin/resetPassword.config.js").default || {}),

  Object.assign({
      path: 'pages/padLogin/SelectIdentity',
      load: function() {
          return import("./pages/padLogin/SelectIdentity")
      }
  }, require("./pages/padLogin/SelectIdentity.config.js").default || {}),

  Object.assign({
      path: 'pages/mine/pad',
      load: function() {
          return import("./pages/mine/pad")
      }
  }, require("./pages/mine/pad.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/ClueManagement',
      load: function() {
          return import("./pages/appPage/ClueManagement")
      }
  }, require("./pages/appPage/ClueManagement.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/ClueDetail',
      load: function() {
          return import("./pages/appPage/ClueDetail")
      }
  }, require("./pages/appPage/ClueDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/padLogin/rouseAppPage',
      load: function() {
          return import("./pages/padLogin/rouseAppPage")
      }
  }, require("./pages/padLogin/rouseAppPage.config.js").default || {}),

  Object.assign({
      path: 'pages/appOutLink/index',
      load: function() {
          return import("./pages/appOutLink/index")
      }
  }, require("./pages/appOutLink/index.config.js").default || {}),

  Object.assign({
      path: 'pages/mine/padAbout',
      load: function() {
          return import("./pages/mine/padAbout")
      }
  }, require("./pages/mine/padAbout.config.js").default || {}),

  Object.assign({
      path: 'pages/mine/accountCancellation',
      load: function() {
          return import("./pages/mine/accountCancellation")
      }
  }, require("./pages/mine/accountCancellation.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/neighborhoodSearch',
      load: function() {
          return import("./pages/appPage/neighborhoodSearch")
      }
  }, require("./pages/appPage/neighborhoodSearch.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/neighborhoodDetail',
      load: function() {
          return import("./pages/appPage/neighborhoodDetail")
      }
  }, require("./pages/appPage/neighborhoodDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/houseTypeDetail',
      load: function() {
          return import("./pages/appPage/houseTypeDetail")
      }
  }, require("./pages/appPage/houseTypeDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/HouseTypeLibrary',
      load: function() {
          return import("./pages/appPage/HouseTypeLibrary")
      }
  }, require("./pages/appPage/HouseTypeLibrary.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/DesignHome',
      load: function() {
          return import("./pages/appPage/DesignHome")
      }
  }, require("./pages/appPage/DesignHome.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/DesignSearch',
      load: function() {
          return import("./pages/appPage/DesignSearch")
      }
  }, require("./pages/appPage/DesignSearch.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/DesignDetail',
      load: function() {
          return import("./pages/appPage/DesignDetail")
      }
  }, require("./pages/appPage/DesignDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/DesignDetailMobile',
      load: function() {
          return import("./pages/appPage/DesignDetailMobile")
      }
  }, require("./pages/appPage/DesignDetailMobile.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/DesignShare',
      load: function() {
          return import("./pages/appPage/DesignShare")
      }
  }, require("./pages/appPage/DesignShare.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/MyConstribute',
      load: function() {
          return import("./pages/appPage/MyConstribute")
      }
  }, require("./pages/appPage/MyConstribute.config.js").default || {}),

  Object.assign({
      path: 'pages/schemePreview/drawing',
      load: function() {
          return import("./pages/schemePreview/drawing")
      }
  }, require("./pages/schemePreview/drawing.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/AIGenerate',
      load: function() {
          return import("./pages/appPage/AIGenerate")
      }
  }, require("./pages/appPage/AIGenerate.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/InspirationList',
      load: function() {
          return import("./pages/appPage/InspirationList")
      }
  }, require("./pages/appPage/InspirationList.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/FullHousePreview',
      load: function() {
          return import("./pages/appPage/FullHousePreview")
      }
  }, require("./pages/appPage/FullHousePreview.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/DesignHelp',
      load: function() {
          return import("./pages/appPage/DesignHelp")
      }
  }, require("./pages/appPage/DesignHelp.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/ProxyDesignRefund',
      load: function() {
          return import("./pages/appPage/ProxyDesignRefund")
      }
  }, require("./pages/appPage/ProxyDesignRefund.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/FloorPlan',
      load: function() {
          return import("./pages/appPage/FloorPlan")
      }
  }, require("./pages/appPage/FloorPlan.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/FloorPlanDetail',
      load: function() {
          return import("./pages/appPage/FloorPlanDetail")
      }
  }, require("./pages/appPage/FloorPlanDetail.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/FloorPlanAction',
      load: function() {
          return import("./pages/appPage/FloorPlanAction")
      }
  }, require("./pages/appPage/FloorPlanAction.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/agree',
      load: function() {
          return import("./pages/appPage/agree")
      }
  }, require("./pages/appPage/agree.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/editModalPage',
      load: function() {
          return import("./pages/appPage/editModalPage")
      }
  }, require("./pages/appPage/editModalPage.config.js").default || {}),

  Object.assign({
      path: 'pages/hdd/panoramaShare',
      load: function() {
          return import("./pages/hdd/panoramaShare")
      }
  }, require("./pages/hdd/panoramaShare.config.js").default || {}),

  Object.assign({
      path: 'pages/member/buyMember',
      load: function() {
          return import("./pages/member/buyMember")
      }
  }, require("./pages/member/buyMember.config.js").default || {}),

  Object.assign({
      path: 'pages/member/payOrder',
      load: function() {
          return import("./pages/member/payOrder")
      }
  }, require("./pages/member/payOrder.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/MineModal',
      load: function() {
          return import("./pages/appPage/MineModal")
      }
  }, require("./pages/appPage/MineModal.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/ExcellentDesign3D',
      load: function() {
          return import("./pages/appPage/ExcellentDesign3D")
      }
  }, require("./pages/appPage/ExcellentDesign3D.config.js").default || {}),

  Object.assign({
      path: 'pages/activityPage/ReceiveWelfare',
      load: function() {
          return import("./pages/activityPage/ReceiveWelfare")
      }
  }, require("./pages/activityPage/ReceiveWelfare.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/customerAcquisition/AcquisitionList',
      load: function() {
          return import("./pages/appPage/customerAcquisition/AcquisitionList")
      }
  }, require("./pages/appPage/customerAcquisition/AcquisitionList.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/customerAcquisition/CollectionList',
      load: function() {
          return import("./pages/appPage/customerAcquisition/CollectionList")
      }
  }, require("./pages/appPage/customerAcquisition/CollectionList.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/customerAcquisition/preview3D',
      load: function() {
          return import("./pages/appPage/customerAcquisition/preview3D")
      }
  }, require("./pages/appPage/customerAcquisition/preview3D.config.js").default || {}),

  Object.assign({
      path: 'pages/panoramaExample/panorama3D',
      load: function() {
          return import("./pages/panoramaExample/panorama3D")
      }
  }, require("./pages/panoramaExample/panorama3D.config.js").default || {}),

  Object.assign({
      path: 'pages/panoramaExample/panoramaList',
      load: function() {
          return import("./pages/panoramaExample/panoramaList")
      }
  }, require("./pages/panoramaExample/panoramaList.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/InputReferrer',
      load: function() {
          return import("./pages/appPage/InputReferrer")
      }
  }, require("./pages/appPage/InputReferrer.config.js").default || {}),

  Object.assign({
      path: 'pages/designPreview/index',
      load: function() {
          return import("./pages/designPreview/index")
      }
  }, require("./pages/designPreview/index.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/FreeDesign',
      load: function() {
          return import("./pages/appPage/FreeDesign")
      }
  }, require("./pages/appPage/FreeDesign.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/combo',
      load: function() {
          return import("./pages/landingPage/combo")
      }
  }, require("./pages/landingPage/combo.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/AgreementPage',
      load: function() {
          return import("./pages/appPage/AgreementPage")
      }
  }, require("./pages/appPage/AgreementPage.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/appPicker',
      load: function() {
          return import("./pages/appPage/appPicker")
      }
  }, require("./pages/appPage/appPicker/index.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/videoPage/index',
      load: function() {
          return import("./pages/appPage/videoPage/index")
      }
  }, require("./pages/appPage/videoPage/index.config.js").default || {}),

  Object.assign({
      path: 'pages/appPage/legalNoticePage/index',
      load: function() {
          return import("./pages/appPage/legalNoticePage/index")
      }
  }, require("./pages/appPage/legalNoticePage/index.config.js").default || {}),

  Object.assign({
      path: 'pages/qiweiPage/index',
      load: function() {
          return import("./pages/qiweiPage/index")
      }
  }, require("./pages/qiweiPage/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/solution/paramsEdit',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/solution/paramsEdit")
      }
  }, require("./pages/landingPage/mobileAndPadPage/solution/paramsEdit/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/solution/technicalAuth',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/solution/technicalAuth")
      }
  }, require("./pages/landingPage/mobileAndPadPage/solution/technicalAuth/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/solution/digitalDrawing',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/solution/digitalDrawing")
      }
  }, require("./pages/landingPage/mobileAndPadPage/solution/digitalDrawing/index.config.js").default || {}),

  Object.assign({
      path: 'pages/landingPage/mobileAndPadPage/solution/materialDownload',
      load: function() {
          return import("./pages/landingPage/mobileAndPadPage/solution/materialDownload")
      }
  }, require("./pages/landingPage/mobileAndPadPage/solution/materialDownload/index.config.js").default || {}),

]


var inst = createReactApp(component, React, ReactDOM, config)
createRouter(inst, config, React)
initPxTransform({
  designWidth: 750,
  deviceRatio: {"640":1.17,"750":1,"828":0.905}
})
